function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm-.857 6.214A.215.215 0 0 1 11.357 6h1.286a.215.215 0 0 1 .214.214V13.5a.215.215 0 0 1-.214.214h-1.286a.215.215 0 0 1-.214-.214zM12 18a1.286 1.286 0 1 1 1.286-1.286A1.286 1.286 0 0 1 12 18z" /></svg>;
});